export default "__VITE_ASSET__Bnxfrqtr__"